import { FC } from 'react';

import { VSpacingContainer } from '@hh.ru/magritte-ui';
import { useSelectorNonNullable } from '@hh.ru/redux-create-reducer';

import EmptyState from 'src/components/EmptyState';
import { CurrentSectionState } from 'src/models/pages/profession';
import SectionCalculator from 'src/pages/Profession/components/SectionCalculator';
import SectionCourses from 'src/pages/Profession/components/SectionCourses';
import SectionStatistics from 'src/pages/Profession/components/SectionStatistics';
import CareerTrack from 'src/widgets/CareerTrack';

const SectionsContent: FC = () => {
    const currentSection = useSelectorNonNullable((state) => state.pageProfession.currentSection);

    if (currentSection === CurrentSectionState.STATISTIC) {
        return <SectionStatistics />;
    }

    if (currentSection === CurrentSectionState.CALCULATOR) {
        return <SectionCalculator />;
    }

    if (currentSection === CurrentSectionState.COURSES) {
        return (
            <VSpacingContainer default={40}>
                <SectionCourses />
            </VSpacingContainer>
        );
    }

    if (currentSection === CurrentSectionState.CAREERTRACK) {
        return (
            <VSpacingContainer default={40}>
                <CareerTrack />
            </VSpacingContainer>
        );
    }

    return <EmptyState />;
};

export default SectionsContent;
